import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined'
import { Box } from 'shared/components/Box/Box'
import { Button } from 'shared/components/Button/Button'
import { Text } from 'shared/components/Text/Text'
import { Handler, HandlerOf } from 'shared/helpers/typeHelper'
import {
  AccidentTypeDetail,
  DrivingAccident,
  DrivingViolationType,
  DrivingViolationTypeDetail,
} from 'shared/models/employment'
import { darkGray, midGray } from 'shared/theme/colors'

import {
  addBullet,
  formatCMV,
  ViolationCard,
  ViolationEditIcon,
  ViolationErrorIcon,
  ViolationWrap,
} from './ViolationsList'

interface AccidentsListProps {
  accidents: DrivingAccident[]
  onEdit: HandlerOf<DrivingAccident>
  onAdd: Handler
}

export function AccidentsList({ accidents, onEdit, onAdd }: AccidentsListProps) {
  function renderContent() {
    if (!accidents.length) {
      return (
        <ViolationCard onClick={onAdd}>
          <Box mt={2} />
          <Button margin="0 auto" variant="text" icon={<AddCircleOutlineOutlinedIcon />}>
            Add accident
          </Button>
          <Box mt={2} />
        </ViolationCard>
      )
    }

    return (
      <>
        {accidents.map((accident) => (
          <ViolationCard
            key={accident.id}
            onClick={() => onEdit(accident)}
            $hasMoreViolations={accidents.length > 1}
          >
            {accident.isComplete ? <ViolationEditIcon /> : <ViolationErrorIcon />}
            <Text variant="uppercaseLabel2" fontColor={midGray}>
              {addBullet([
                new Date(accident.date).toLocaleString('en-us', { month: 'short', year: 'numeric' }),
                accident.address,
              ])}
            </Text>
            <Text variant="label3" fontColor={darkGray} mt={1}>
              {addBullet([
                AccidentTypeDetail.get(accident.accidentType),
                formatCMV(accident.isInCommercialVehicle),
                formatDOT(accident.isDotRecordable),
                formatCharged(accident.violationType, accident.isCharged),
              ])}
            </Text>
          </ViolationCard>
        ))}
        <Box mt={2} />
        <Button margin="0 auto" variant="text" icon={<AddCircleOutlineOutlinedIcon />} onClick={onAdd}>
          Add accident
        </Button>
      </>
    )
  }

  return <ViolationWrap>{renderContent()}</ViolationWrap>
}

export function formatDOT(check?: boolean) {
  if (check === true) return 'DOT recordable'
  if (check === false) return 'Not DOT recordable'
  return null
}

export function formatCharged(violationType: DrivingViolationType, check?: boolean) {
  if (check === true) return DrivingViolationTypeDetail.get(violationType)
  if (check === false) return 'No Violation'
  return null
}
